<template>
  <span>
    <div class="page-level-functions">
      <action-button
        variant="success float-right ml-3"
        text="Guardar"
        i="fas fa-save"
        @click="saveClicked"
      ></action-button>

      <router-link to="/applications">
        <action-button
          variant="outline-success float-right ml-3"
          text="Regresar"
          i="fas fa-arrow-circle-left"
        ></action-button>
      </router-link>
    </div>

    <hr class="page-level-functions-separator" />

    <div class="sub-content-wrapper">
      <div class="mt-3 mb-3">
        <section-title :content="pageTitle" icon="fas fa-user"></section-title>
      </div>
      <validation-observer ref="applicationVO" v-slot="{ dirty }">
        <save-observer name="applicationSO" :dirty="dirty">
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <div class="form-group">
                <label class="field-label">Aplicación</label>

                <validation-provider
                  vid="applicationNameVP"
                  :rules="'required'"
                  v-slot="{ invalid, errors }"
                      
                  :custom-messages="
                      {'required':'Favor de entrar el nombre de la aplicación.'}"
                >
                  <custom-input
                    v-model="appData.applicationName"
                    type="text"
                    class="read-only" 
                    maxlength="100"
                    :error="errors[0]"                                   
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-md-3 col-sm-12">
              <div class="form-group">
                <label class="field-label">Nombre a Mostrar</label>

                <validation-provider
                  vid="applicationDisplayNameVP"
                  :rules="'required'"
                  v-slot="{ invalid, errors }"
                  :custom-messages="
                      {'required':'Favor de entrar el nombre a mostrar.'}"
                >
                  <custom-input
                    v-model="appData.displayName"
                    type="text"
                    maxlength="100"
                    :error="errors[0]"                    
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="form-group">
                <label class="field-label">Descripción</label>

                <validation-provider :rules="'required'" v-slot="{ invalid, errors }">
                  <custom-input
                    v-model="appData.description"
                    type="text"
                    maxlength="200"
                    :error="errors[0]"
                    custom-error-msg="Favor de entrar la descripción de la aplicación."
                  />
                </validation-provider>
              </div>
            </div>
          </div>
        </save-observer>
      </validation-observer>
    </div>
  </span>
</template>

<script>
import ActionButton from '@/components/common/ActionButton'
import SectionTitle from '@/components/common/SectionTitle'
import {
  addNewApplication,
  getApplication,
  updateApplication,
} from '@/modules/applications/api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import SaveObserver from '@/components/common/SaveObserver'
import CustomInput from '@/components/common/form/CustomInput'
import {} from '@/mixins/vue-alerts'
import { mapActions } from 'vuex'
import { name as appsModuleName } from '@/modules/applications/store/'

export default {
  name: 'ManageApplication',

  components: {
    ActionButton,
    SectionTitle,
    ValidationObserver,
    ValidationProvider,
    SaveObserver,
    CustomInput,
  },
  props: {
    appId: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      appData: {
        applicationName: null,
        description: null,
        applicationId: null,
      },
    }
  },
  computed: {
    inEditMode() {
      return !!this.appId
    },
    pageTitle() {
      return this.inEditMode
        ? 'Información de la Aplicación'
        : 'Añadir Información de la Aplicación'
    },
  },
  async mounted() {
    if (this.inEditMode) {
      this.appData = await getApplication(this.appId)
    }
  },
  methods: {
    async saveClicked() {
      var self = this
      let passed = await this.$refs.applicationVO.validate()

      let operationPromise = null;
      let operation = null;

      if (passed) {
        
        if (this.inEditMode) {
          operation = 'U';
          operationPromise = updateApplication(self.appData);

        } else {
          operation = 'I';
          operationPromise = addNewApplication(self.appData);
        }

        if(operationPromise){
          operationPromise.then((res) => {
              self.handleOperationSuccess(res,operation, self)
            })
            .catch((err) => {
              self.handleOperationErrors(err, operation, self)
            })
        }

      }else {
        self.AlertValidationError()
      }

    },
    handleOperationSuccess(res, op, self) {
      if (res.status == 200) {
        self.setAffectedApplicationData({
          applicationId: res.data.applicationId,
          operation: op,
        })
        self.$router.push({ name: 'applications' })
      }
    },
    handleOperationErrors(err, op, self) {
      let showValidationToast = false

      if (err.response.status === 409) {
        showValidationToast = true

        self.$refs.applicationVO.setErrors({
          applicationNameVP: ['Ya existe una aplicación con este nombre. Entre un nombre distinto e intente de nuevo.',
          ],
        })
      } 

      if (showValidationToast) {
        self.AlertValidationError()
      } else {
        let verb = op == 'I' ? 'creando' : op == 'U' ? 'actualizando' : '?'
        self.Toast(
          'Error',
          err.response?.data?.message ??
            'Ocurrio un error ' + verb + ' la aplicación.',
          'error'
        )
      }
    },

    ...mapActions(appsModuleName, ['setAffectedApplicationData']),
  },
}
</script>

<style scoped>

.read-only >>> input {
  pointer-events: none;
  cursor: not-allowed !important;
  background-color: #f8f8f8;
}

</style>
